import { React, useState } from "react";
import { TextField, InputAdornment } from "@mui/material";
import { istInteger } from "../../lib";

export default function BetragInput(props) {
  const { value, onChange, disabled, size, currency, fullWidth, label, von, bis, negativ, variant = "oulined" } = props;
  const [errorState, setErrorState] = useState("");
  
  function Format(newValue, range) {
    var tmpvalue = newValue;
    var neg = 0;
    if (negativ) {
      if (tmpvalue.split("-").length - 1 === 1) neg = 1;
    }
    tmpvalue = tmpvalue.toString().replace(".", ",");
    tmpvalue = tmpvalue.replace(/,/g, "");
    if (negativ) tmpvalue = tmpvalue.replace(/-/g, "");
    tmpvalue = tmpvalue.replace(/^0+/g, "");

    if (istInteger(tmpvalue) === false) {
      return;
    }

    if (range > "0") {
      setErrorState("")
      if (tmpvalue.length > 9) {
        return;
      }

      if (tmpvalue.length === 0) {
        tmpvalue = "0";
      } else if (tmpvalue.length === 1) {
        tmpvalue = "0.0" + tmpvalue.toString();
      } else if (tmpvalue.length === 2) {
        tmpvalue = "0." + tmpvalue.toString();
      } else if (tmpvalue.length > 2) {
        tmpvalue = tmpvalue.substr(0, tmpvalue.length - 2) + "." + tmpvalue.substr(tmpvalue.length - 2, 2);
      }
    }
    if (neg === 1) tmpvalue = tmpvalue * -1;

    if (range === "2") {
      if (Number(tmpvalue) < Number(von)) {
        setErrorState("Mind. " + von);
        setTimeout(function() {
          setErrorState("");
        }, 2000); // clear error state after 3 seconds
        Format(von, "0");
        return;
      }
      if (Number(tmpvalue) > Number(bis)) {
        setErrorState("Max. " + bis);
        setTimeout(function() {
          setErrorState("");
        }, 3000); // clear error state after 3 seconds
        Format(bis, "0");
        return;
      }
    }

    onChange(Number(tmpvalue));
  }

  function checkRange(newValue) {
    if (Number(von) == NaN || Number(bis) == NaN || (Number(von) == 0 && Number(bis) == 0)) return;
    Format(newValue, "2");
  }

  function getValue() {
    var neg = 0;
    var tmpvalue = value;
    tmpvalue = tmpvalue.toString().replace(".", ",");

    if (Number(tmpvalue) === 0) {
      return "0,00";
    } else {
      if (tmpvalue.includes("-")) {
        neg = 1;
        tmpvalue = tmpvalue.substr(1);
      }
      var pos = tmpvalue.indexOf(",");
      if (pos === -1) {
        tmpvalue = tmpvalue + ",00";
      } else if (pos === tmpvalue.length - 1) {
        tmpvalue = tmpvalue + "00";
      } else if (pos === tmpvalue.length - 2) {
        tmpvalue = tmpvalue + "0";
      } else if (pos < tmpvalue.length - 3) {
        tmpvalue = tmpvalue.substr(0, pos + 3);
      }

      if (tmpvalue.length > 10) {
        tmpvalue = tmpvalue.substr(tmpvalue.length - 9, 9);
      }
      return neg === 1 ? "-" + tmpvalue : tmpvalue;
    }
  }

  return (
    <TextField
      label={label}
      disabled={disabled}
      size={size ? size : ""}
      fullWidth={fullWidth}
      error={errorState !== ""}
      helperText={errorState !== "" ? errorState : ""}
      value={getValue()}
      onChange={(e) => Format(e.target.value, "1")}
      onBlur={(e) => checkRange(e.target.value)}
      InputProps={
        currency && {
          startAdornment: <InputAdornment position="start">{currency}</InputAdornment>,
        }
      }
    />
  );
}
